import { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './sub-nav-bar.module.scss';
import { augmentClassName } from '../../../utils/GlobalCssProxy';
import Scrollspy from 'react-scrollspy';
import { useSelect } from 'downshift';
import ButtonInvest from './button-invest';
import useSubNavBarStore from '../../../stores/profile/modules/use-sub-nav-bar-store';
import { INVEST_BUTTON_MODES } from '../../../stores/profile/use-participant-holdings-store';

const className = augmentClassName(styles);

const SubNavBar = ({ hideInvestButton, navOptions, onClickInvestButton }) => {
  const { handleScrollSpyUpdate, investButtonMode, selectedItem } = useSubNavBarStore({
    navOptions,
    hideInvestButton
  });

  const {
    getLabelProps,
    getMenuProps,
    getToggleButtonProps,
    getItemProps,
    highlightedIndex,
    isOpen
  } = useSelect({
    items: navOptions,
    itemToString: i => i.label,
    selectedItem
  });

  const triggerRef = useRef();

  return (
    <div
      {...className(
        'root',
        'd-flex',
        'justify-content-between',
        'font-family-sans-serif',
        'h-100',
        'pr-sm-3',
        'd-print-none'
      )}
    >
      <Scrollspy
        items={navOptions.map(opt => opt.id)}
        currentClassName={className.string('active')}
        {...className(
          'd-none',
          'd-sm-flex',
          'mb-0',
          'pl-0',
          'h-100',
          'flex-grow-1',
          'd-print-none'
        )}
        offset={-300}
        onUpdate={handleScrollSpyUpdate}
      >
        {navOptions.map((option, index) => {
          return (
            <li
              data-key={`${option.id || ''}-${index}`}
              key={`${option.id || ''}-${index}`}
              {...className(
                'nav-item',
                'list-inline-item',
                'position-relative',
                'h-100',
                'd-flex',
                'align-items-center',
                'px-5'
              )}
            >
              <a
                href={`#${option.id}`}
                {...className('text-black', 'text-uppercase', 'stretched-link')}
              >
                {option.label}
              </a>
            </li>
          );
        })}
      </Scrollspy>
      <div
        {...className(
          'd-flex',
          'd-sm-none',
          'w-100',
          'justify-content-around',
          'align-items-center'
        )}
      >
        <label {...getLabelProps()} />
        <a
          {...className(
            'nav-item',
            'text-black',
            'text-uppercase',
            'text-left',
            'w-100',
            'position-relative',
            'dropdown-trigger'
          )}
          ref={triggerRef}
          role="button"
          {...getToggleButtonProps()}
        >
          {selectedItem.label}
        </a>
        {
          <ul
            data-target="#"
            {...className('dropdown_items', isOpen ? '' : 'd-none', 'w-100')}
            {...getMenuProps({ refKey: triggerRef.current })}
          >
            {navOptions.map((item, index) => (
              <li
                data-key={`${item.id || ''}-${index}`}
                key={`${item.id || ''}-${index}`}
                {...className(
                  'dropdown_item',
                  'position-relative',
                  item === selectedItem && 'selected',
                  index === highlightedIndex && 'highlighted'
                )}
                {...getItemProps({ item, index })}
              >
                <a {...className('stretched-link')} href={`#${item.id}`}>
                  {item.label}
                </a>
              </li>
            ))}
            {investButtonMode !== INVEST_BUTTON_MODES.hide || !hideInvestButton ? (
              <li {...className('dropdown_item')}>
                <ButtonInvest
                  {...className('w-100')}
                  mode={investButtonMode}
                  onClick={onClickInvestButton}
                />
              </li>
            ) : null}
          </ul>
        }
      </div>
      {investButtonMode !== INVEST_BUTTON_MODES.hide ? (
        <div {...className('align-self-center', 'd-none', 'd-sm-block')}>
          <ButtonInvest mode={investButtonMode} onClick={onClickInvestButton} />
        </div>
      ) : null}
    </div>
  );
};

SubNavBar.defaultProps = {
  navOptions: []
};

SubNavBar.propTypes = {
  hideInvestButton: PropTypes.bool,
  navOptions: PropTypes.array,
  onClickInvestButton: PropTypes.func
};

export default SubNavBar;
